import React, { useEffect} from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from './Header';
import Home from './Home';
import Chechout from './Checkout';
import { useStateValue } from "./StateProvider";
import Login from './Login';
import Payment from './Payment';
import { auth } from './firebase';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const promise = loadStripe("pk_test_51HyiP8IqcAgPsJAiVo6qolGo9AvEjcMpimvG1YxF4f6Uy6CViLr2iqqDyxnICMOVMyLTjQpjGnMeDxd1diiFh6mX00VA4mMy1u");

function App() {
  const [{ user }, dispatch] = useStateValue();

  useEffect(() => {
    const unsubscribe =  auth.onAuthStateChanged((authUser) => {
      if (authUser) {
          // the use is logged in...
          dispatch({
            type: 'SET_USER',
            user: authUser,
          });
      } else {
          // the user is logged out...
          dispatch({
            type: 'SET_USER',
            user: null,
          });
      };
    });
    
    return () => {
      unsubscribe();
    }
  }, []);

  return (
    <Router>
    <div className="app">
      <Switch>
        <Route path = "/checkout">
        <Header/>
        <Chechout/>
        </Route>
        <Route path = "/payment">
        <Header/>
        <Elements stripe={promise}>
        <Payment />
        </Elements>
        </Route>
        <Route path = "/login">
          <Login />
        </Route>
        <Route path = "/">
        <Header />
        <Home />
        </Route>
      </Switch>
    </div>
    </Router>
  );
}

export default App;
